import { PackageStatus } from '@allocab/allocab-dedicated-driver-types/lib/src/dedicated-package/types';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { columns } from './tableData';
import { TripPackageFilters } from './TripPackageFilters';
import { STATUS_SEARCH_PARAMS_KEY } from './TripPackageStatusFilter';
import { Table } from '../../components/table/Table';
import { PACKAGES_LIMIT, prefetchTripPackagesPage, useFetchTripPackages } from '../../hooks/useFetchTripPackages';
import { useDriverOptions } from '../../services/driver-options/useDriverOptions';

const tableStatus = ['ACCEPTED', 'CANCELLED', 'DRAFT', 'IN_PROGRESS', 'PROPOSED', 'TERMINATED'];

export const TripPackageTable = () => {
  const { driverOptions } = useDriverOptions();

  const [searchParams] = useSearchParams();
  const currentPage = Math.max(parseInt(searchParams.get('page') ?? '1'), 1);
  const direction = (searchParams.get('direction') ?? 'desc') as 'desc' | 'asc';
  const orderBy = searchParams.get('orderBy') ?? 'startDate';
  const status = (searchParams.get(STATUS_SEARCH_PARAMS_KEY)?.split(',') ?? tableStatus) as PackageStatus[];

  const { data, isLoading, isFetching, isPreviousData } = useFetchTripPackages(
    {
      direction,
      orderBy,
      status,
    },
    currentPage,
  );

  const nbPages = Math.ceil((data?.totalItems ?? 0) / PACKAGES_LIMIT);

  useEffect(() => {
    if (currentPage > 1) {
      prefetchTripPackagesPage({ direction, status, orderBy }, currentPage - 1);
    }
    if (currentPage < nbPages) {
      prefetchTripPackagesPage({ direction, status, orderBy }, currentPage + 1);
    }
  }, [currentPage, direction, nbPages, status, orderBy]);

  return (
    <div>
      <TripPackageFilters />
      <Table
        identifier="id"
        columns={columns}
        data={data?.items}
        isLoading={isLoading}
        isFetching={isPreviousData && isFetching}
        nbPages={nbPages}
        context={driverOptions}
        totalItems={data?.totalItems ?? 0}
      />
    </div>
  );
};
